import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  select_input: {
    width: "312px",
    margin: "5px 5px 0px 5px",
    [theme.breakpoints.down("1020")]: {
      width: "100%",
    },
    [theme.breakpoints.down("899")]: {
      width: "65%",
    },
    [theme.breakpoints.down("865")]: {
      margin: 5,
    },
  },
}));

const languageOptions = [
  { name: "Portuguese", value: "pt" },
  { name: "Hindi", value: "hi" },
  { name: "French", value: "fr" },
  { name: "Italian", value: "it" },
  { name: "German", value: "de" },
  { name: "Japanese", value: "ja" },
  { name: "Spanish", value: "es" },
  { name: "English", value: "en" },
  { name: "Mandarin", value: "cmn" },
  { name: "Russian", value: "ru" },
];

const LanguageSelect = ({ language, onLanguageChange }) => {
  const classes = useStyles();

  return (
    <FormControl
      variant="outlined"
      size="small"
      className={classes.select_input}
    >
      <InputLabel id="language-select-label">Language</InputLabel>
      <Select
        labelId="language-select-label"
        id="language-select"
        value={language}
        label="Language"
        onChange={(e) => onLanguageChange(e.target.value)}
      >
        {languageOptions.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSelect;
